import React from 'react';
import img from '../images/web.svg'; 
import img2 from '../images/app.svg';
import img3 from '../images/hosting.svg';
import img4 from '../images/consultation.svg';
import CommonContainer from "./CommonContainer";
import { commonStyles } from "../pages/commonStyles";
const Services = () => {

    return (
       <div id="services" className="bg-gray-100 py-20">
        <CommonContainer>
            <section data-aos="zoom-in-down">
                    <div className="text-center my-2 py-2">
                        <h1 className={`${commonStyles.heading} text-blue-900 mb-6`}>SERVICES</h1>
                        
                        {/* <div className='flex justify-center'>
                            <div className='w-24 border-b-4 border-blue-900'></div>
                        </div> */}
                        <h1 className={`${commonStyles.heading} mb-6`}>We are deeply committed to the growth and success of our clients.</h1>
                    </div>

                   <div className="py-6" data-aos="fade-down" data-aos-delay="600">
                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-8">
                            <div
                          className="lg:col-span-2 bg-white rounded-xl shadow-lg p-8 hover:bg-slate-500 hover:shadow-2xl transition-all duration-300 group flex flex-col">
                               <div className="flex flex-col h-full">
                                <img alt="card img" className="mx-auto h-36 object-contain mb-6 transition-transform duration-500 group-hover:scale-110" src={img} />
                                   <h3 className={`${commonStyles.cardTitle} text-center group-hover:text-white mb-5`}>
  IT Consulting
</h3>  <p className={`${commonStyles.cardText} text-left group-hover:!text-white`}>
  The QuadProsoft consulting team comprises senior IT and
  management leads, offering an average of about eighty years of
  experience per team.
</p>
                                </div>
                            </div>

                           <div className="lg:col-span-2 bg-white rounded-xl shadow-lg p-8 hover:bg-slate-500 hover:shadow-2xl transition-all duration-300 group flex flex-col">
  <div className="flex flex-col h-full">
    <img
      alt="card img"
      className="mx-auto h-36 object-contain mb-6 transition-transform duration-500 group-hover:scale-110"
      src={img2}
    />

    <h3 className={`${commonStyles.cardTitle} text-center group-hover:text-white mb-5`}>
      Staffing and IT Solutions
    </h3>

    <p className={`${commonStyles.cardText} text-left group-hover:!text-white`}>
      We understand that the key to profitability in an increasingly competitive and complicated market is the ability to fluidly deploy resources to address precise business and technological challenges.
    </p>
  </div>
</div>

                          <div className="lg:col-span-2 bg-white rounded-xl shadow-lg p-8 hover:bg-slate-500 hover:shadow-2xl transition-all duration-300 group flex flex-col">
  <div className="flex flex-col h-full">
    <img
      alt="card img"
      className="mx-auto h-36 object-contain mb-6 transition-transform duration-500 group-hover:scale-110"
      src={img3}
    />

    <h3 className={`${commonStyles.cardTitle} text-center group-hover:text-white mb-5`}>
      Application Development
    </h3>

    <p className={`${commonStyles.cardText} text-left group-hover:!text-white`}>
      QuadProsoft's Application Development services offer a wide range of development-related capabilities, including architecting, UI design, product development, version upgrades, quality assurance, etc.
    </p>
  </div>
</div>

                           <div className="lg:col-start-2 lg:col-span-2 bg-white rounded-xl shadow-lg p-8 hover:bg-slate-500 hover:shadow-2xl transition-all duration-300 group flex flex-col">
  <div className="flex flex-col h-full">
    <img
      alt="card img"
      className="mx-auto h-36 object-contain mb-6 transition-transform duration-500 group-hover:scale-110"
      src={img4}
    />

    <h3 className={`${commonStyles.cardTitle} text-center group-hover:text-white mb-5`}>
      Digital Marketing
    </h3>

    <p className={`${commonStyles.cardText} text-left group-hover:!text-white`}>
      Quadprosoft technologies with their expertise and experience in Digital Marketing offer clients brand recognition, customer engagement, and effective online marketing solutions.
    </p>
  </div>
</div>

                            <div className="lg:col-span-2 bg-white rounded-xl shadow-lg p-8 hover:bg-slate-500 hover:shadow-2xl transition-all duration-300 group flex flex-col">
  <div className="flex flex-col h-full">
    <img
      alt="card img"
      className="mx-auto h-36 object-contain mb-6 transition-transform duration-500 group-hover:scale-110"
      src={img4}
    />

    <h3 className={`${commonStyles.cardTitle} text-center group-hover:text-white mb-5`}>
      Accounting
    </h3>

    <p className={`${commonStyles.cardText} text-left group-hover:!text-white`}>
      We offer bookkeeping services for individuals and businesses to assist you in achieving your short- and long-term financial goals through reliable and accurate accounting services.
    </p>
  </div>
</div>                
                        </div>
                    </div>
            </section>

            <section>
                <div className="py-12">
                    <div className="flex flex-col-reverse lg:flex-row items-center justify-between gap-24 py-24" data-aos="zoom-out">
                       <div className="lg:w-1/2 flex flex-col lg:mx-4">
                            <div className="text-blue-900 mb-4 h-[72px] flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 24 24" className='fill-current'><path d="M2 12h2a7.986 7.986 0 0 1 2.337-5.663 7.91 7.91 0 0 1 2.542-1.71 8.12 8.12 0 0 1 6.13-.041A2.488 2.488 0 0 0 17.5 7C18.886 7 20 5.886 20 4.5S18.886 2 17.5 2c-.689 0-1.312.276-1.763.725-2.431-.973-5.223-.958-7.635.059a9.928 9.928 0 0 0-3.18 2.139 9.92 9.92 0 0 0-2.14 3.179A10.005 10.005 0 0 0 2 12zm17.373 3.122c-.401.952-.977 1.808-1.71 2.541s-1.589 1.309-2.542 1.71a8.12 8.12 0 0 1-6.13.041A2.488 2.488 0 0 0 6.5 17C5.114 17 4 18.114 4 19.5S5.114 22 6.5 22c.689 0 1.312-.276 1.763-.725A9.965 9.965 0 0 0 12 22a9.983 9.983 0 0 0 9.217-6.102A9.992 9.992 0 0 0 22 12h-2a7.993 7.993 0 0 1-.627 3.122z"></path><path d="M12 7.462c-2.502 0-4.538 2.036-4.538 4.538S9.498 16.538 12 16.538s4.538-2.036 4.538-4.538S14.502 7.462 12 7.462zm0 7.076c-1.399 0-2.538-1.139-2.538-2.538S10.601 9.462 12 9.462s2.538 1.139 2.538 2.538-1.139 2.538-2.538 2.538z"></path></svg>
                            </div>
                            <h3 className="text-4xl md:text-5xl lg:text-[20px] font-bold text-[#153E75] mb-6">
  We <span className="text-5xl md:text-6xl lg:text-[25px] font-black">Build</span>
</h3>
                            <div>
                                <p className="text-[18px] leading-9 text-gray-700">
                                    With over 10 years experience in software analysis and design and a deep understanding of the latest IT trends and solutions, we provide customized recommendations and strategies to help you improve your operations, reduce costs, and increase efficiency.
                                </p>
                            </div>
                        </div>
                        <div className="lg:w-1/2 flex flex-col lg:mx-4">
                            <div className="text-blue-900 mb-6 h-[32px] flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 24 24" className='fill-current'><path d="m7.375 16.781 1.25-1.562L4.601 12l4.024-3.219-1.25-1.562-5 4a1 1 0 0 0 0 1.562l5 4zm9.25-9.562-1.25 1.562L19.399 12l-4.024 3.219 1.25 1.562 5-4a1 1 0 0 0 0-1.562l-5-4zm-1.649-4.003-4 18-1.953-.434 4-18z"></path></svg>
                            </div>
                           <h3 className="text-4xl md:text-5xl lg:text-[22px] font-bold text-[#153E75] mb-6">
  We <span className="text-5xl md:text-6xl lg:text-[25px] font-black">Collaborate</span>
</h3>
                            <div>
                                <p className="text-[18px] leading-9 text-gray-700">We can collaborate with your existing tech team to scale existing software applications or design customized software applications that suits your everyday need and simplifies various processes.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            </CommonContainer>
        </div>
    )
}

export default Services;